/**
 * Shared display-label mapping for ABA enums.
 *
 * Backend enums stay stable; the UI runs values through here so users
 * never see raw values like "on_hold" or "most_to_least".
 */

export const PROGRAM_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  active: "Active",
  on_hold: "On Hold",
  closed: "Closed",
  archived: "Archived",
};

export const TARGET_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  waiting: "Waiting",
  baseline: "Baseline",
  acquisition: "Acquisition",
  generalization: "Generalization",
  mastered: "Mastered",
  maintenance: "Maintenance",
  on_hold: "On Hold",
  hold: "On Hold",
  closed: "Closed",
  discontinued: "Discontinued",
  archived: "Archived",
};

export const SESSION_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  completed: "Completed",
  awaiting_review: "Awaiting Review",
  reviewed: "Reviewed",
  returned_for_correction: "Returned for Correction",
  voided: "Voided",
};

export const PROMPTING_ORDER_LABELS: Record<string, string> = {
  most_to_least: "Most-to-Least",
  least_to_most: "Least-to-Most",
  custom: "Custom Order",
  "most-to-least": "Most-to-Least",
  "least-to-most": "Least-to-Most",
};

export const MEASUREMENT_LABELS: Record<string, string> = {
  "Percent Correct": "Trial Accuracy",
  "Task Analysis": "Task Analysis",
  "Frequency": "Frequency",
  "Duration": "Duration",
  "Latency": "Latency",
  "Interval": "Interval Recording",
  "Interval Recording": "Interval Recording",
  "ABC Behaviour": "ABC Behaviour",
};

export const TRIAL_RESULT_LABELS: Record<string, string> = {
  correct: "Correct",
  incorrect: "Incorrect",
  prompted: "Correct with Prompt",
  no_response: "No Response",
  na: "Not Applicable",
};

export function label(map: Record<string, string>, raw: string | null | undefined, fallback = "—"): string {
  if (raw == null || raw === "") return fallback;
  return map[raw] ?? raw;
}
